import { useTranslation } from 'react-i18next'


import useModalStore from '@features/modal/model'
import InfoModal from '@features/modal/ui/error'
import styles from '@features/modal/ui/styles.module.scss'


interface OpenErrorInfoModalProps {
  title?: string;
  description?: string;
}

export default function useErrorInfoModal () {
  const { t: tc } = useTranslation('common')
  const { openModal, closeModal } = useModalStore()

  const openErrorInfoModal = ({
    title,
    description,
  }: OpenErrorInfoModalProps = {}) => {
    openModal('info', <InfoModal />, {
      title: title ?? tc('modal.error.title'),
      description: description ?? tc('modal.error.description'),
      classes: {
        content: styles['error-info-modal-content'],
      },
    })
  }

  const closeErrorInfoModal = () => {
    closeModal('info')
  }

  return {
    openErrorInfoModal,
    closeErrorInfoModal,
  }
}
